import { Component, OnInit } from '@angular/core';
import { FormGroup, FormControl } from '@angular/forms';
import { ResourceService, CalendarLanguagueService } from '@services/index.service';
import { ResponseDataBase } from '@interfaces/index.interface';
import { AppConstants } from '@app/appConstants';
import * as moment from 'moment';

import { TableModule } from 'primeng/table';

@Component({
  selector: 'app-login-attemps',
  templateUrl: './login-attemps.page.html',
  styleUrls: ['./login-attemps.page.scss']
})
export class LoginAttempsComponent implements OnInit {
  searchForm: FormGroup;
  alert;
  searchedLogingAttemps;

  constructor(public _resourceService: ResourceService,
    public locale: CalendarLanguagueService) {
    this.searchForm = new FormGroup({
      'date': new FormControl(),
      'userName': new FormControl(),
    });
  }

  searchLoginAttemps() {
    delete this.searchedLogingAttemps;
    if (!this.searchForm.value.date && !this.searchForm.value.userName) {
      this.alert = 'PLEASE_FILL_AT_LEAST_ONE_FIELD'
    } else if (typeof (this.searchForm.value.date) == 'string' && moment(this.searchForm.value.date, "DD-MM-YYYY").format('YYYY-MM-DD') == 'Invalid date') {
      this.alert = "PLEASE_SELECT_VALID_DATE_CAN_USE_CALENDAR";
    } else {
      delete this.alert;
      this._resourceService.loading = true;
      let params: any = {};
      if (this.searchForm.value.date) {
        // let formatedDate = this._resourceService.formatDate(this.searchForm.value.date);
        let formatedDate = moment(this.searchForm.value.date, "DD-MM-YYYY").format('YYYY-MM-DD')
        params.date = formatedDate
      };
      if (this.searchForm.value.userName) { params.userName = this.searchForm.value.userName };
      this._resourceService.searchLogingAttemps(params).subscribe(data => {
        let response = data as ResponseDataBase;
        if (response.METADATA.STATUS == AppConstants.STATUS.OK) {
          if (response.result.length) {
            this.searchedLogingAttemps = response.result;
          } else {
            this.alert = "NO_RESULTS";
          }
          this._resourceService.loading = false;
        } else {
          this.alert = response.METADATA.ERROR_MESSAGE;
          this._resourceService.loading = false;
        }
        this._resourceService.loading = false;
      });
    }
  }

  ngOnInit() {
  }

}
